// Permission action types
export type PermissionAction = 'view' | 'create' | 'edit' | 'delete';

// Module names
export type ModuleName =
  | 'dashboard'
  | 'tickets'
  | 'customers'
  | 'users'
  | 'vendors'
  | 'products'
  | 'roles'
  | 'settings'
  | 'reports';

// Permission structure for a module
export interface ModulePermissions {
  view?: boolean;
  create?: boolean;
  edit?: boolean;
  delete?: boolean;
}

// Full permissions object
export type Permissions = {
  [key in ModuleName]?: ModulePermissions;
};

// Role interface
export interface Role {
  ref: number;
  name: string;
  display_name: string;
  description?: string;
  permissions: Permissions;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

// Default permissions for new roles
export const DEFAULT_PERMISSIONS: Permissions = {
  dashboard: { view: true },
  tickets: { view: true, create: false, edit: false, delete: false },
  customers: { view: false, create: false, edit: false, delete: false },
  users: { view: false, create: false, edit: false, delete: false },
  vendors: { view: false, create: false, edit: false, delete: false },
  products: { view: false, create: false, edit: false, delete: false },
  roles: { view: false, create: false, edit: false, delete: false },
  settings: { view: false, edit: false },
  reports: { view: false },
};

// Admin has all permissions
export const ADMIN_PERMISSIONS: Permissions = {
  dashboard: { view: true },
  tickets: { view: true, create: true, edit: true, delete: true },
  customers: { view: true, create: true, edit: true, delete: true },
  users: { view: true, create: true, edit: true, delete: true },
  vendors: { view: true, create: true, edit: true, delete: true },
  products: { view: true, create: true, edit: true, delete: true },
  roles: { view: true, create: true, edit: true, delete: true },
  settings: { view: true, edit: true },
  reports: { view: true },
};

// Module display names (for UI)
export const MODULE_DISPLAY_NAMES: Record<ModuleName, string> = {
  dashboard: 'Dashboard',
  tickets: 'Tickets',
  customers: 'Müşteriler',
  users: 'Kullanıcılar',
  vendors: 'Bayiler',
  products: 'Ürünler',
  roles: 'Roller',
  settings: 'Ayarlar',
  reports: 'Raporlar',
};

// Action display names (for UI)
export const ACTION_DISPLAY_NAMES: Record<PermissionAction, string> = {
  view: 'Görüntüle',
  create: 'Oluştur',
  edit: 'Düzenle',
  delete: 'Sil',
};
